import React from "react";
import Loader from "../../components/Loader";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import is_null from "../../helpers/is_null";
import moment from "../../helpers/moment";
import PageTitle from "../../components/PageTitle";
import ErrorResponse from "../../components/ErrorResponse";

const Notifications = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["msNotificationSeen"],
    queryFn: async () => {
      const req = await axiosget(`ms_notification`);
      return req?.data;
    },
  });

  return (
    <>
      <PageTitle title={`MY LECTURER NOTIFICATIONS`} sub={`View notifications from lecturers and respond to them`} />
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.type !== undefined && <ErrorResponse type={`danger`} message={`${data?.message}`} />}
      {!data?.length && (
        <ErrorResponse
          type={`info`}
          message={`Sorry, system could not find any notification at the moment`}
          title={`no notification`.toUpperCase()}
        />
      )}
      {data?.type === undefined && (
        <ul className="icon-data-list w-100">
          <>
            {!is_null(data) &&
              data?.map((v) => (
                <li>
                  <div className="d-flex">
                    <img src={v?.staff?.photo} alt="user" />
                    <div>
                      <p className="text-info mb-1 text-uppercase">
                        {v?.staff?.firstname} {v?.staff?.middlename} {v?.staff?.lastname} {` | `} {v?.results?.code} {` `}
                        {v?.results?.name}
                      </p>
                      <p className="mb-0">{v?.post}</p>
                      <small>{moment(v?.createdAt)} ago</small>
                    </div>
                  </div>
                </li>
              ))}
          </>
        </ul>
      )}
    </>
  );
};

export default Notifications;
